module.exports = __webpack_public_path__ + "img/desk2.66bdd03f.png";